<template>
  <ux-form
    ref="form"
    :data="formData"
    width="440px"
    :colon="true"
    :rules="rules"
    label-width="78px"
    data-automation="addCode"
  >
    <ux-form-item :label="$t('HT.apiStepThree.http')" prop="http_status">
      <ux-select v-model="formData.http_status" :options="$opt.http_status"></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addCode.code')" prop="code">
      <ux-select
        v-model="formData.code"
        :options="apiCode"
        :props="{ label: 'code', value: 'code' }"
        @change="change()"
      ></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.apiStepOne.remark')" prop="message">
      <ux-input v-model="formData.message" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addCode.errCode')" prop="sub_code">
      <ux-input
        v-model="formData.sub_code"
        :maxlength="50"
        :placeholder="$t('HT.addCode.errCode.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addCode.errMsg')" prop="sub_message">
      <ux-input
        v-model="formData.sub_message"
        :maxlength="50"
        :placeholder="$t('HT.addCode.errMsg.placeholder')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          code: '', // 响应码
          message: '', // 描述
          sub_code: '', // 错误结果码
          sub_message: '', // 错误描述
          http_status: '' // HTTP状态码
        };
      }
    }
  },

  data() {
    return {
      codeList: [],
      formData: JSON.parse(JSON.stringify(this.data)),
      apiCode: [
        {
          code: 10000,
          message: this.$t('HT.addCode.msg1')
        },
        {
          code: 20000,
          message: this.$t('HT.addCode.msg2')
        },
        {
          code: 20001,
          message: this.$t('HT.addCode.msg3')
        },
        {
          code: 40001,
          message: this.$t('HT.addCode.msg4')
        },
        {
          code: 40002,
          message: this.$t('HT.addCode.msg5')
        },
        {
          code: 40004,
          message: this.$t('HT.addCode.msg6')
        }
      ],
      rules: this.$rul.addCode()
    };
  },

  created() {
    this.formData.code = this.formData.code + '';
    this.getCodeList();
  },

  methods: {
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant + '').indexOf(queryString) === 0;
      };
    },

    select(val) {
      this.formData.code = val + '';
    },

    change() {
      if (this.formData.code == 10000) {
        this.formData.message = this.$t('HT.addCode.msg1');
      }
      if (this.formData.code == 20000) {
        this.formData.message = this.$t('HT.addCode.msg2');
      }
      if (this.formData.code == 20001) {
        this.formData.message = this.$t('HT.addCode.msg3');
      }
      if (this.formData.code == 40001) {
        this.formData.message = this.$t('HT.addCode.msg4');
      }
      if (this.formData.code == 40002) {
        this.formData.message = this.$t('HT.addCode.msg5');
      }
      if (this.formData.code == 40004) {
        this.formData.message = this.$t('HT.addCode.msg6');
      }
    },

    querySearch(queryString, cb) {
      let restaurants = this.codeList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getCodeList() {
      this.$uxLoading.show();
      this.$api.code.getCodeList().then((res) => {
        if (res.code == 10000) {
          this.codeList = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-code {
  width: 440px;
}
span {
  width: 85px;
}
</style>
